import { StandardEvents } from '@shopify/events';

/**
 * Таблицата „Технически данни“ (blocks/tehnicheski-danni.liquid).
 * При смяна на варианта взима новото съдържание от HTML-а, който variant-picker вече е изтеглил.
 */
class TehnicheskiDanni extends HTMLElement {
  connectedCallback() {
    this.target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    this.target?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.target?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  #onProductSelect = (event) => {
    event.promise
      ?.then(({ detail }) => {
        const updated = detail?.html?.getElementById(this.id);
        if (!updated) return;
        this.innerHTML = updated.innerHTML;
        this.hidden = updated.hasAttribute('hidden');
      })
      .catch(() => {});
  };
}

if (!customElements.get('tehnicheski-danni')) {
  customElements.define('tehnicheski-danni', TehnicheskiDanni);
}
